export const GET_CLIENT_NOTES_REQUEST = 'GET_CLIENT_NOTES_REQUEST';
export const GET_CLIENT_NOTES_SUCCESS = 'GET_CLIENT_NOTES_SUCCESS';
export const GET_CLIENT_NOTES_FAILURE = 'GET_CLIENT_NOTES_FAILURE';

export const GET_CLIENT_NOTE_ATTACHMENT_REQUEST = 'GET_CLIENT_NOTE_ATTACHMENT_REQUEST';
export const GET_CLIENT_NOTE_ATTACHMENT_SUCCESS = 'GET_CLIENT_NOTE_ATTACHMENT_SUCCESS';
export const GET_CLIENT_NOTE_ATTACHMENT_FAILURE = 'GET_CLIENT_NOTE_ATTACHMENT_FAILURE';